<template>
  <div class="">
    <!-- aboutus intro -->
    <section class="aboutusIntro">
      <b-container fluid>
        <b-row class="intro-section justify-content-around">
          <b-col xl="6" lg="12" md="12" style="display: flex; align-items: center; margin-left: auto;">
            <div class="text-section">
              <div>
                <h1 class="mb-3"><b>سياسة الخصوصيــة</b></h1>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>


    <!-- Privacy Policy -->
    <section class="privacy">
      <b-container fluid>
        <b-row class="justify-content-around" style="text-align: right;">
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">سياسة الخصوصية:</span>
              </div>
              <p>
                تُعد سياسة الخصوصية في تطبيق تخطي من العناصر الأساسية التي يعتمد عليها العلاج النفسي، حيث يجب أن يشعر المستخدم بالأمان والثقة ليتمكن من التعبير بحرية عن أفكاره ومشاعره وتجربته، وفي غياب ضمانات الخصوصية، قد يتردد المستخدم في السعي للحصول على المساعدة أو قد يخفي معلومات مهمة عن المختص، مما يؤثر سلباً على فعالية العلاج
              </p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">ضمان سرية المعلومات:</span>
              </div>
              <p>تعتبر خصوصية المستخدم في تطبيق تخطي من الأولويات الأساسية، لذا نلتزم بعدم الإفصاح عن أي معلومات شخصية، سواء للمختصين أو المستفيدين، مثل "الاسم، العنوان، البريد الإلكتروني، وغيرها"، لأي جهة كانت، وذلك وفقاً لما يحدده القانون المعمول به. ولن يُسمح بالوصول إلى هذه المعلومات إلا لفريق العمل المحترف المسؤول عن إدارة تطبيق تخطي.</p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">جمع البيانات:</span>
              </div>
              <p>
                نحن في (تخطي) نجمع ونحتفظ بالبيانات التي يقوم المستخدم بإدخالها، والتي تشمل على وجه التحديد البيانات
                التالية:

              <ul>
                <li>
                  المعلومات المطلوبة من المستخدم في حسابه الشخصي على التطبيق: الاسم، رقم الهاتف المحمول، وكلمة المرور،
                  حيث يتم تخزين كلمة المرور بشكل مشفر لضمان سريتها.
                </li>
                <li>
                  الملاحظات والاعتراضات التي يرفعها المستفيد من خلال خاصية (تواصل معنا).
                </li>
                <li>
                  تقييم المستخدم للتطبيق والاختصاصيين والخدمات المتاحة.
                </li>
                <li>
                  الرسائل التي يرسلها المستفيد على أي بريد إلكتروني خاص بنا.
                </li>
              </ul>
              </p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">مدة الاحتفاظ بالبيانات:</span>
              </div>
              <p>
                نحتفظ بمعلوماتك الشخصية للمدة الضرورية لتقديم خدماتنا لك، ولحين استمرارك في الاستفادة من هذه الخدمات،
                وكذلك طوال فترة تسجيل حسابك لدينا. كما قد نكون ملزمين بالاحتفاظ ببعض المعلومات الشخصية الناتجة عن
                استخدامك لتطبيقنا، وذلك امتثالاً للقوانين أو اللوائح أو القرارات التي تتطلب منا ذلك، مع الحرص على تقليل
                هذه البيانات إلى الحد الأدنى المطلوب وفقاً للقانون. </p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">خلل تقني في التطبيق وتوقف الخدمة:
                </span>
              </div>
              <p>
                نحن نعمل بجد لضمان تقديم الجلسات في بيئة آمنة ومستقرة تحافظ على خصوصيتك. في حال حدوث أي مشكلة تقنية،
                نرجو منك التواصل معنا وسنقوم بحلها على الفور. </p>
            </div>
          </b-col>
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">
                  الحساب الشخصي وكلمة المرور: </span>
              </div>
              <p>
                يتعهد المستفيد بالحفاظ على سرية معلوماته الشخصية ورقم التعريف السري، ويوافق على عدم مشاركتها مع أي جهات
                أخرى. ويتحمل المستفيد كافة المسؤوليات الناتجة عن ذلك، دون أن يتحمل تطبيق تخطي أي مسؤولية. كما يتحمل
                المستفيد مسؤولية جميع البيانات والمعلومات التي يقوم بمشاركتها عبر التطبيق. </p>
            </div>
          </b-col>
          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">إدخال أو تعديل سياسات الخصوصية: </span>
              </div>
              <p>
                يجوز لنا تعديل أو إضافة إلى سياسة الخصوصية في أي وقت. عند حدوث ذلك، سنقوم بنشر النسخة المحدثة على تطبيق
                (تخطي).
              </p>
              <p>
                 إن استمرارك في استخدام خدماتنا وعدم إلغاء حسابك الشخصي يعتبر قبولاً منك لما ورد في سياسة الخصوصية بعد التحديث.
              </p>
              <p>
               تهدف كافة المعلومات الطبية المتاحة على موقع تخطي إلى تعزيز الوعي الصحي وتوفير خدمات الرعاية النفسية عبر الإنترنت، ولا يمكن أن تحل محل استشارة الطبيب المتخصص.
              </p>              
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">خدمات تطبيق تخطي:</span>
              </div>
              <p>
                <ul>
                  <li>
                    استشارات نفسية وتطويرية.
                  </li>
                  <li>
                    نوادي الدعم النفسي ولقاءات مسجلة.
                  </li>
                  <li>
                    تقديم تعليم طبي وتدريب مستمر مع تصميم برامج علاجية مخصصة لكل نوع من الاضطرابات النفسية بشكل منفصل.
                  </li>
                  <li>
                    تطبيق تخطي الحل الذهبي لتعزيز الحالة النفسية وتقليل الضغوط.
                  </li>
                  <li>
                    جميع الحقوق محفوظة لشركة تخطي الطبية ©2026
                  </li>            
                </ul>
              </p>
            </div>
          </b-col>

          <b-col xl="12" lg="12" md="12" class="text-section">
            <div>
              <div class="title">
                <span class="title-green">حمل تطبيق تخطي الآن</span>
              </div>
              <p>
                <ul>
                  <li>
                    واحصل على جلستك الأولى بخصم 50%
                  </li>
                  <li>
                  النشرة البريدية:
                  </li>
                  
                  <li>
                    انضم إلى قائمتنا البريدية واحصل على آخر العروض وأحدث المقالات والأخبار
                  </li>
                  <li>
                  خدمات تخطي
                  </li>
                  <li>
                    انضم كطبيب او كمعالج
                  </li>
                  <li>
                    مدونة تخطي
                  </li>
                  <li>
                    تواصل معنا
                  </li>
                  <li>
                    الشروط والاحكام
                  </li>
                  <li>
                    التسويق بالعمولة
                  </li>
                </ul>
              </p>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

        <!-- subscribe -->
    <section class="subscribe">
      <div>
        <div>
          <div class="">
            <div class="col-md-12 col-sm-12 col-xs-12"
              style="display: flex;align-items: center;justify-content: center;text-align: center;">
              <div class="py-5 my-5">
                <div class="">
                  <h2>تريد التعرف على كافة  خدمات تخطى والإشتراك بهم؟</h2>
                  <div class="description">
                    <br> 
                    <p v-if="!googleplay && !applestore" style="color: red;">
                      <b>التطبيق غير متاح حاليًا، لكنه سيكون متوفرًا قريبًا.</b>
                      <br>
                      <b-button @click="goToRoute('contactus')" class="px-4 py-2 my-4" variant="primary">
                      <span>تواصل معنا </span>
                      </b-button>
                    </p> 
                  </div>
                  <div v-if="googleplay || applestore" class="action-btns mt-2">
                    <b-button v-if="applestore" @click="goTowebsite(applestore)" class="px-4 py-3 mx-4 my-3"
                      style="background-color: black;color:white !important;border: black !important;">
                      <div class="carousel-btn-in-div px-3"
                        style="display: flex;align-items: center;justify-content: center;">
                        <div style="width: 35px;height:35px;color: white;" class="ml-3">
                          <img style="width: 35px;height: 40px;margin-top: -3px;"
                            src="../assets/images/Apple_logo_white.svg.png">
                        </div>
                        <div style="font-size: 14px;">
                          <span>متوفر على</span>
                          <br>
                          <span>App Store</span>
                        </div>
                      </div>
                    </b-button>
                    <b-button v-if="googleplay" @click="goTowebsite(googleplay)" class="px-4 py-3 mx-4 my-3"
                      variant="primary" style="color:white !important;border: black !important;">
                      <div class="carousel-btn-in-div px-3"
                        style="display: flex;align-items: center;justify-content: center;">
                        <div style="width: 40px;height: 40px;" class="carousel-btn-in-div-icon ml-3">
                          <svg class="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" d="M0,0h40v40H0V0z"></path>
                            <g>
                              <path
                                d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                fill="#EA4335"></path>
                              <path
                                d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                fill="#FBBC04"></path>
                              <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z"
                                fill="#4285F4"></path>
                              <path
                                d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                fill="#34A853"></path>
                            </g>
                          </svg>
                        </div>
                        <div style="font-size: 14px;">
                          <span>متوفر على</span>
                          <br>
                          <span>Google Play</span>
                        </div>
                      </div>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import store from "../store/index.js"
import expertCarousel from "../components/ExpertCarousel.vue"
import { sendRequest } from '../utils/RequestHelper.js'

export default {
  name: 'Home',
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
      items: [],
    }
  },

  components: {
    expertCarousel
  },
  methods: {
    goTowebsite(link) {
      window.open(link, "_blank");
    },
    goToContactus(name) {
      this.$router.push({
        name
      })
    },
    goToRoute(name, id) {
      this.$router.push({
        name,
        id
      });
    },
     loadData() {
      this.pageIsLoading = true;
      let body = {
        pageNumber: 1,
        pageSize: 999999
      }
      this.pageIsLoading = true;
      sendRequest('post', 'CourseAndEnrichment/CourseSearch',true , body,
        (response) => {
          this.items = response.data.data.items;
          this.pageIsLoading = false;
        },
        () => {
          this.pageIsLoading = false;
          this.alertType = 'danger';
          this.alertText = 'Error loading data';
        }
      );
    }
  },
  created() {
    this.langDec = store.getters.getLangData
    this.loadData();
  }
}
</script>

<style scoped>

/* subscribe */
.subscribe {
  background-color: #f5f5f5;
}

.aboutusIntro .intro-section {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../assets/images/privacyPolicy-terms.png);
  background-size: cover;
  background-position: center;
  width: auto;
  height: 450px !important;
  color: white;
}

.aboutusIntro .text-section {
  display: flex;
  align-items: center;
  margin-right: 70px !important;
}

.aboutusIntro .text-section h2 {

  font-size: 40px !important;
  font-weight: bolder !important;
  color: white;
}


.privacy {
  padding: 80px 20px;
}

.privacy .text-section {
  display: flex;
  align-items: center;
  text-align: right;
  padding: 0px 170px;
  width: 100% !important;
}

.privacy .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.privacy .text-section p {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}

@media (max-width: 991.98px) {
  .privacy .text-section {
    padding: 0 30px;
  }
}

@media (max-width: 575.98px) {
  .privacy .text-section {
    padding: 0 12px;
  }
}
</style>
